/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Setting_LabelInputs */

const fr_extra_session_setting_label = /** @type {(inputs: Extra_Session_Setting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances supplémentaires par période`)
};

/**

* @param {Extra_Session_Setting_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_setting_label = /** @type {((inputs?: Extra_Session_Setting_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Setting_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_setting_label(inputs)
});